import React, { memo, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import desktopPreviewContainer from '@Theme/icons/preview-web.svg';
import { Select } from 'antd';
import './webpushPreview.less';

const BASE = '//d107ygk0jso0v4.cloudfront.net/frontline/images/';

const OVERLAY =
  BASE + 'placeholderImgHorizontal-f6a7793f4c3000d2467c99c87913ea93.svg';

const ICON =
  BASE + 'web-push/placeholder-small-d282371abebcc5dce91979af42768214.png';

const CHROME = BASE + 'chrome-824783f57c2acec1501a1beb2d743cc8.svg';

const FIREFOX = BASE + 'firefox-c8d2fdc5157c455f11a1c4e38e035e24.svg';

const Selector = ({ type, setType }) => {
  return (
    <Select
      onChange={setType}
      value={type}
      style={{ width: 180 }}
      className="chart-selector"
      bordered={false}
    >
      <Select.Option value="CHROME_WIN10">Chrome Windows 10</Select.Option>
      <Select.Option value="CHROME_WIN">Chrome Windows</Select.Option>
      <Select.Option value="CHROME_MAC">Chrome Mac</Select.Option>
      <Select.Option value="CHROME_ANDROID">Chrome Android</Select.Option>
      <Select.Option value="FIREFOX_WIN">Firefox Windows</Select.Option>
      <Select.Option value="FIREFOX_MAC">Firefox Mac</Select.Option>
    </Select>
  );
};

function PreviewContent({ variation, type }) {
  const overlay = variation?.image || OVERLAY;

  const icon = variation?.icon || ICON;

  const PUSH_TYPE_BANNER = variation?.pushType === 'BANNER';

  const buttons = variation?.androidButtons || [];

  const showButtons = variation?.showAndroidPushButtons && buttons.length !== 0;

  const subject = isEmpty(variation.subject) ? 'Title' : variation?.subject;

  const message = isEmpty(variation.message) ? 'Message' : variation?.message;

  switch (type) {
    case 'CHROME_WIN10':
    case 'CHROME_WIN':
      return (
        <div className="preview-content-win10">
          {PUSH_TYPE_BANNER && (
            <img width="100%" height="200px" src={overlay} alt={subject} />
          )}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                paddingInline: 16,
              }}
            >
              <span style={{ fontSize: 12, color: '#ccc' }}>Google Chrome</span>
            </div>
            <div
              style={{
                display: 'flex',
                gap: 8,
                padding: 16,
              }}
            >
              <img src={icon} height={80} style={{ objectFit: 'cover' }} />
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontWeight: 'medium', color: '#f2f2f2' }}>
                  {subject}
                </span>
                <span style={{ fontSize: 12, color: '#f2f2f2' }}>
                  {message}
                </span>
              </div>
            </div>
            {showButtons && (
              <div className="preview-content-buttons">
                {buttons.map((button, index) => {
                  const label = button?.label || `Button ${index + 1}`;

                  return (
                    <div key={index} className="preview-content-button">
                      {label}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      );
    case 'CHROME_MAC':
    case 'FIREFOX_MAC':
      return (
        <div className="preview-content-chrome-mac">
          <img
            src={type === 'FIREFOX_MAC' ? FIREFOX : CHROME}
            height={40}
            width={40}
            style={{ marginInlineStart: 8 }}
          />
          <div className="preview-content-info-chrome-mac">
            <span style={{ fontWeight: 'medium' }}>{subject}</span>
            <span style={{ fontSize: 10 }}>localhost</span>
            <span style={{ fontSize: 12 }}>{message}</span>
          </div>
          <img src={icon} height={50} />
          <div className="preview-content-actions-chrome-mac">
            <div className="preview-content-action-chrome-mac">Close</div>
            <div style={{ background: '#ccc', width: '100%', height: 1 }} />
            <div className="preview-content-action-chrome-mac">More</div>
          </div>
        </div>
      );
    case 'CHROME_ANDROID':
      return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 16,
              padding: 8,
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              <span style={{ fontSize: 12 }}>
                Google Chrome • localhost • 1m
              </span>
              <span style={{ fontWeight: 'medium' }}>{subject}</span>
              <span style={{ fontSize: 12 }}>{message}</span>
            </div>
            <img src={icon} height="50px" />
          </div>
          <div className="preview-chrome-android">
            {showButtons ? (
              <div className="preview-content-buttons">
                {buttons.map((button, index) => {
                  const label = button?.label || `Button ${index + 1}`;

                  return (
                    <div key={index} className="preview-content-button">
                      {label}
                    </div>
                  );
                })}
              </div>
            ) : (
              <div style={{ padding: 12 }}>
                <span style={{ fontWeight: 'bold', color: '#767676' }}>
                  SITE SETTINGS
                </span>
              </div>
            )}
          </div>
        </div>
      );

    case 'FIREFOX_WIN':
      return (
        <div className="preview-content-firefox-win">
          <span style={{ fontWeight: 'medium' }}>{subject}</span>
          <img src={icon} width="50px" style={{ marginInline: 'auto' }} />
          <span style={{ fontSize: 12 }}>{message}</span>
          <span style={{ fontSize: 10 }}>localhost</span>
        </div>
      );
    default:
      return null;
  }
}

function WebpushPreview({ variation }) {
  const [type, setType] = useState('CHROME_WIN10');

  return (
    <div style={{ position: 'relative' }}>
      <div className="preview-environment-selector">
        <Selector type={type} setType={setType} />
      </div>
      <img src={desktopPreviewContainer} />
      <div className="preview-content-container">
        <PreviewContent type={type} variation={variation} />
      </div>
    </div>
  );
}

const Memoized = memo(WebpushPreview);

export { Memoized as WebpushPreview };
